namespace RedBullMOBILE360.CustomerCare {
    export class ThreeThreeZeroNotificationColumns {
        static columnsKey = 'CustomerCare.ThreeThreeZeroNotification';
    }
}